/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import * as React from 'react';
import {useNavigate} from "react-router-dom";

import { useAppContextoReact } from '../../servicos/app/AppContextoReact';
import AppConfig from '../../AppConfig';

/* COMPONENTES */

import Paper from '@mui/material/Paper';
import {Box, Grid} from '@mui/material';
import FormLogin from './form-login';
import ResetPassword from './resetPassword';

const IMGLOGIN = AppConfig.PATHS.Login.Login+'bgAcervo.jpg';


export default function Login()
{
	const navigate = useNavigate();
	const appContext = useAppContextoReact();
	
	const [ehCarregando, setEhCarregando] = React.useState<boolean>(true);
	const [newPassword, setNewPassword] =  React.useState<boolean>(false);

	async function pageLoad()
	{
		try
		{
			await appContext?.usuario.ehLogado();
			navigate(AppConfig.PATHS.Dashboard.programas.lista as string);
		}
		catch(e)
		{
			return false;
		}
		finally
		{
			setEhCarregando(false);
		}
	}

	React.useEffect(() =>
	{
		pageLoad();
	},[appContext])
	
	// firebase.initializeApp(firebaseConfig);

	return <>
		{
			!ehCarregando ?
				<Grid container component="main" sx={{ height: '100vh' }}>
					{/* <CssBaseline /> */}

					{/* 
					*** BLOCO FORMULÁRIO  
					*/}
					<Grid item xs={12} sm={8} md={5} component={Paper} elevation={0} square display={'flex'} alignItems={'center'} justifyContent={'center'} >
						<Box
							sx={{
							my: 8,
							mx: 4,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center'
							}}
						>
							{
								!newPassword ?
									<FormLogin setNewPassword={setNewPassword} />
								:
									<ResetPassword setNewPassword={setNewPassword} />
							}
						</Box>
					</Grid>

					{/* 
					*** BLOCO IMAGEM  
					*/}
					<Grid
						item
						xs={false}
						sm={4}
						md={7}
						sx={{
							backgroundImage: `url('${IMGLOGIN}')`,
							backgroundRepeat: 'no-repeat',
							backgroundColor: '#f2f2f2',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
						}}
					/>			
				</Grid>
			: null
		}		
	</>
}

